var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity-search-autocomplete',_vm._b({attrs:{"filled":_vm.filled,"types":['TagKey'],"value":_vm.tagKeyEntity,"prepend-icon":null,"label":_vm.label || _vm.$t('tagKeyAutocomplete.tagKey.label'),"hide-details":"","support-create":""},on:{"input":_vm.handleTagKeySelection}},'entity-search-autocomplete',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }